import * as React from 'react';
import { css } from 'aphrodite';
import { Uploader } from '@citrite/sf-api';
import { EmptyUploadIcon, PageTitle } from '@sharefiledev/flow-web';
import { getCanDrag, t } from '../../util';
import { styles } from './DragAndDrop.styles';
import { useDragAndDropContext } from './DragAndDropContext';
export var DragAndDrop = function DragAndDrop(_ref) {
  var onItemsSelected = _ref.onItemsSelected,
    scopedOverlay = _ref.scopedOverlay;
  var _useDragAndDropContex = useDragAndDropContext(),
    isDraggingFiles = _useDragAndDropContex.isDraggingFiles,
    onFilesDropped = _useDragAndDropContex.onFilesDropped,
    cancelDragAndDrop = _useDragAndDropContex.cancelDragAndDrop;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      onDrop: onDrop,
      onDragLeave: cancelDragAndDrop,
      className: css(styles.dragArea, scopedOverlay && styles.scopedOverlay, isDraggingFiles && styles.showDragArea)
    }, /*#__PURE__*/React.createElement(EmptyUploadIcon, {
      size: scopedOverlay ? 100 : 200
    }), /*#__PURE__*/React.createElement(PageTitle, {
      textAlign: "center"
    }, t('citrix-files-ui:upload.drop_files_here')))
  );
  function onDrop(event) {
    if (!getCanDrag() || event.dataTransfer.files.length === 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    Uploader.parseItems(event.dataTransfer).then(function (items) {
      onItemsSelected(items);
      onFilesDropped();
    });
  }
};